import {gsap} from "gsap";
import is_mobile from "../miscellaneous/responsive";


/**
 * Initialisation de la navigation principale
 */
export default function init_main_nav(){
    (function ($) {
        $( document ).ready(function() {
            let main_nav = $("#main-nav"),
                body = $('body');
            body.on('open_mobile_nav_event',main_nav, open_menu_animation)
                .on('close_mobile_nav_event',main_nav, close_menu_animation);
        });
        $(window).on("resize", resize_handler);
    })(jQuery);
}

/**
 * Timeline gsap pour l'animation du menu en mode mobile
 * @type {gsap.core.Timeline}
 */
const tl = gsap.timeline({
    defaults: {
        duration: 0.5,
        ease: "power3.easeOut"
    }
} );

/**
 * Animation d'ouverture du menu en mode mobile
 */
const open_menu_animation = () => {
    tl.clear()
        .to("#nav-wrapper", {x:0})
        .to("#nav-wrapper>ul li", {x:"0px",autoAlpha:1, stagger:0.05}, '-=0.4');

}

/**
 * Animation de fermeture du menu en mode mobile
 */
const close_menu_animation = () => {
    tl.clear()
        .to("#nav-wrapper>ul li", {x:"-30%", autoAlpha:0, stagger:0.05})
        .to("#nav-wrapper", {x:"-100%"},'-=0.5');
}

const resize_handler = () => {
    let main_nav_li = $("#main-nav ul li"),
        nav_wrapper = $("#nav-wrapper"),
        burger_menu = $("#burger-menu");
    if( !is_mobile() ){

        main_nav_li.css('opacity', 1)
            .css('visibility',"visible")
            .css('transform', "none");
        nav_wrapper.css('transform', "none");
    }else{
        if(!burger_menu.hasClass("open")){
            main_nav_li.css('opacity', 0)
                .css('visibility',"hidden")
                .css('transform', "translate(-30px, 0px)");
            nav_wrapper.css('transform', "translate(-100%, 0px)");
        }
    }
}

